import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VehicleLocationModel } from './../models/OBD/VehicleLocationModel';
import { FuelConsumptionModel } from './../models/OBD/FuelConsumptionModel';
import { VehicleMileageModel } from './../models/OBD/VehicleMileageModel';
import { FuelLevelModel } from '../models/OBD/FuelLevelModel';
import { ControlModuleVoltageModel } from '../models/OBD/ControlModuleVoltageModel';
import { VehicleEngineStatusModel } from '../models/OBD/VehicleEngineStatusModel';
import { EngineCoolantTemperatureModel } from '../models/OBD/EngineCoolantTemperatureModel';
import { SpeedModel } from '../models/OBD/SpeedModel';
import { RpmModel } from '../models/OBD/RpmModel';
import { LowBatteryModel } from '../models/OBD/LowBatteryModel';
import { ApiControllerActionEnum } from '../models/enums/ApiControllerActionEnum';


@Injectable({
  providedIn: 'root'
})
export class ObdService {


constructor(private http: HttpClient) { }


  GetVehicleLocation(deviceId) {
    return this.http.get<VehicleLocationModel>(ApiControllerActionEnum.GetVehicleLocation + `?deviceId=${deviceId}`);
}

GetFuelConsumption(deviceId) {
  return this.http.get<FuelConsumptionModel>(ApiControllerActionEnum.GetFuelConsumption + `?deviceId=${deviceId}`);
}

  GetVehicleMileage(deviceId) {
    return this.http.get<VehicleMileageModel>(ApiControllerActionEnum.GetVehicleMileage + `?deviceId=${deviceId}`);
}

  GetFuelLevel(deviceId) {
    return this.http.get<FuelLevelModel>(ApiControllerActionEnum.GetFuelLevel + `?deviceId=${deviceId}`);

}

  GetControlModuleVoltage(deviceId) {
    return this.http.get<ControlModuleVoltageModel>(ApiControllerActionEnum.GetControlModuleVoltage + `?deviceId=${deviceId}`);
}

  GetVehicleEngineStatus(deviceId) {
    return this.http.get<VehicleEngineStatusModel>(ApiControllerActionEnum.GetVehicleEngineStatus + `?deviceId=${deviceId}`);
}

  GetEngineCoolantTemperature(deviceId) {
    return this.http.get<EngineCoolantTemperatureModel>(ApiControllerActionEnum.GetEngineCoolantTemperature + `?deviceId=${deviceId}`);
}

  GetSpeed(deviceId) {
    return this.http.get<SpeedModel>(ApiControllerActionEnum.GetSpeed + `?deviceId=${deviceId}`);

}

  GetRpm(deviceId) {
    return this.http.get<RpmModel>(ApiControllerActionEnum.GetRpm + `?deviceId=${deviceId}`);
}

  GetLowBattery(deviceId) {
    return this.http.get<LowBatteryModel>(ApiControllerActionEnum.GetLowBattery + `?deviceId=${deviceId}`);
}


}
